import $ from 'jquery';

const initSimulator = function () {
    /*
        Tenso Simulator
        If div with specific ID is present, initialize the corresponding simulator.
        Get the type from data-attribute "simulator_type"
        Get the context env from init-config.js
        By default, "simulator_content_default" is used for the ID of default content wrapper (corresponding to the DV simulator wrapper).
        Time out max is the acceptable time to display simulator or default content
     */
    if ($('#simulator_tenso').length > 0) {
        var currentType = $('#simulator_tenso').data("simulator_type");

        new Vue({
            render: function(h){ return h(TensoSimulator.TensoSimulator, {
                props: {
                    tool: currentType,
                    env: window.cmsGlobals.simulatorConfig.current_env,
                    id_content_default: 'simulator_content_default',
                    time_out_max: window.cmsGlobals.simulatorConfig.time_out
                }
            });
            }
        }).$mount('#simulator_tenso')
    }

    /*
        Bind the Btn simulator Action to pass extra information if existing.
     */
    $(document).on('click','.simulatorAction',function(event){
        event.stopPropagation();
        var href = $(this).attr('href');
        var currentSimulatorAction = $(this).data('simulator-param');

        if (currentSimulatorAction !== null && currentSimulatorAction !== "") {
            href += "?"+currentSimulatorAction;
        }

        $(this).attr("href", href);
    });
}

export {initSimulator};


// WEBPACK FOOTER //
// ./src/js/cms/pri/initSimulator.js